import axios from 'axios';
import { LOADING_CONNECTIONS, RECEIVED_CONNECTIONS, RECEIVED_CONNECTIONS_FAILED } from '../types';
import { identificationType } from '../../constants';
import { createUrl } from '../utils';
import connectionTypes from '../../../client/utils/connections/connectionType';
import hasConnections from '../../../client/utils/connections/hasConnections';
import { trackConnectionsLoaded, trackConnectionsNotLoaded } from '../../../client/utils/trackers/trackConnections';

const validTypes = Object.values(connectionTypes);
const isValidType = type => validTypes.includes(type);

function formatUrl(doi, token) {
  return doi
    ? `/enhancements/article/doi/${encodeURIComponent(doi)}/connections?token=${token}`
    : null;
}

export default {
  urlFormatter: {
    [identificationType.pii]: ({ metadata: { doi }, token }) => formatUrl(
      doi, token,
    ),
    [identificationType.doi]: ({ doi, token }) => formatUrl(
      doi, token,
    ),
  },
  fetch: path => (dispatch) => {
    dispatch({ type: LOADING_CONNECTIONS });
    return axios.get(createUrl(path))
      .then(({ data }) => {
        const connections = Object.entries(data).reduce((acc, [type, items]) => {
          if (items.length && isValidType(type)) {
            return {
              ...acc,
              [type]: items,
            };
          }
          return acc;
        }, {});

        if (hasConnections(connections)) {
          trackConnectionsLoaded();
        } else {
          trackConnectionsNotLoaded();
        }

        dispatch({ type: RECEIVED_CONNECTIONS, payload: connections });
      })
      .catch(() => {
        trackConnectionsNotLoaded();
        dispatch({ type: RECEIVED_CONNECTIONS_FAILED });
      });
  },
};
